var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var genOtherStyle = function (token) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    var componentCls = token.componentCls, colorError = token.colorError, colorWarningBg = token.colorWarningBg, colorWarning = token.colorWarning, colorBorder = token.colorBorder, colorSuccess = token.colorSuccess, lineWidth = token.lineWidth, colorPrimaryBorderHover = token.colorPrimaryBorderHover, colorPrimary = token.colorPrimary, antCls = token.antCls, fontSize = token.fontSize, marginSM = token.marginSM, marginLG = token.marginLG, controlHeight = token.controlHeight, controlHeightSM = token.controlHeightSM, lineHeight = token.lineHeight, controlOutlineWidth = token.controlOutlineWidth, controlOutline = token.controlOutline, colorErrorOutline = token.colorErrorOutline, colorWarningOutline = token.colorWarningOutline, colorTextSecondary = token.colorTextSecondary, paddingXS = token.paddingXS;
    var hover = function (color) {
        if (color === void 0) { color = colorPrimaryBorderHover; }
        return ({
            borderColor: color,
            borderInlineEndWidth: lineWidth,
        });
    };
    var active = function (color, outlineColor) {
        if (color === void 0) { color = colorPrimary; }
        if (outlineColor === void 0) { outlineColor = controlOutline; }
        return ({
            borderColor: color,
            borderInlineEndWidth: lineWidth,
            outline: 0,
            boxShadow: "0 0 0 ".concat(controlOutlineWidth, "px ").concat(outlineColor),
        });
    };
    var extraLabelHeight = controlHeightSM - 2;
    return _a = {},
        _a[componentCls] = (_b = {
                '&-layout-vertical': (_c = {
                        display: 'block'
                    },
                    // Vertical Label: https://github.com/ant-design/ant-design/blob/master/components/form/style/index.ts#L391C1-L404C4
                    _c["".concat(componentCls, "-label")] = {
                        minHeight: lineHeight * fontSize + paddingXS,
                        lineHeight: lineHeight,
                        padding: "0 0 ".concat(paddingXS, "px"),
                        '&-content': {
                            whiteSpace: 'initial',
                            textAlign: 'start',
                        },
                    },
                    _c["".concat(antCls, "-label")] = {
                        minHeight: controlHeight - 10,
                        lineHeight: lineHeight,
                    },
                    _c),
                '&-success': (_d = {},
                    _d["".concat(antCls, "-select-selector,\n          ").concat(antCls, "-cascader-picker,\n          ").concat(antCls, "-picker,\n          ").concat(antCls, "-input,\n          ").concat(antCls, "-input-number,\n          ").concat(antCls, "-input-affix-wrapper,\n          ").concat(antCls, "-input-affix-wrapper,\n          ").concat(antCls, "-input")] = {
                        borderColor: "".concat(colorSuccess, " !important"),
                    },
                    _d["".concat(antCls, "-select-selector,\n        ").concat(antCls, "-cascader-picker,\n        ").concat(antCls, "-picker,\n        ").concat(antCls, "-input,\n        ").concat(antCls, "-input-number,\n        ").concat(antCls, "-input-affix-wrapper,\n        ").concat(antCls, "-input-affix-wrapper:hover,\n        ").concat(antCls, "-input:hover")] = {
                        borderColor: "".concat(colorSuccess, " !important"),
                    },
                    _d["".concat(antCls, "-input-affix-wrapper-focused,\n        ").concat(antCls, "-input-affix-wrapper:focus,\n        ").concat(antCls, "-input-focused,\n        ").concat(antCls, "-input:focus")] = {
                        borderColor: "".concat(colorSuccess, " !important"),
                        borderInlineEndWidth: '1px !important',
                        outline: 0,
                    },
                    _d),
                '&-warning': (_e = {},
                    _e["".concat(antCls, "-select-selector,\n          ").concat(antCls, "-cascader-picker,\n          ").concat(antCls, "-picker,\n          ").concat(antCls, "-input,\n          ").concat(antCls, "-input-number,\n          ").concat(antCls, "-input-affix-wrapper,\n          ").concat(antCls, "-input-affix-wrapper,\n          ").concat(antCls, "-input")] = {
                        borderColor: colorWarning,
                    },
                    _e["".concat(antCls, "-select-selector,\n          ").concat(antCls, "-cascader-picker,\n          ").concat(antCls, "-picker,\n          ").concat(antCls, "-input,\n          ").concat(antCls, "-input-number,\n          ").concat(antCls, "-input-affix-wrapper,\n          ").concat(antCls, "-input-affix-wrapper:hover,\n          ").concat(antCls, "-input:hover")] = {
                        borderColor: colorWarning,
                    },
                    _e["".concat(antCls, "-select:not(").concat(antCls, "-select-disabled):not(").concat(antCls, "-select-customize-input)")] = (_f = {},
                        _f["".concat(antCls, "-select-selector")] = {
                            backgroundColor: colorWarningBg,
                            borderColor: colorWarning,
                        },
                        _f["&".concat(antCls, "-select-open ").concat(antCls, "-select-selector,\n              &").concat(antCls, "-select-focused ").concat(antCls, "-select-selector")] = __assign({}, active(colorWarning, colorWarningOutline)),
                        _f),
                    _e["".concat(antCls, "-input-number,\n          ").concat(antCls, "-picker")] = (_g = {
                            backgroundColor: colorWarningBg,
                            borderColor: colorWarning
                        },
                        _g["&-focused,\n            &:focus"] = __assign({}, active(colorWarning, colorWarningOutline)),
                        _g['&:not([disabled]):hover'] = {
                            backgroundColor: colorWarningBg,
                            borderColor: colorWarning,
                        },
                        _g),
                    _e["".concat(antCls, "-cascader-picker:focus ").concat(antCls, "-cascader-input")] = __assign({ backgroundColor: colorWarningBg }, active(colorWarning, colorWarningOutline)),
                    _e["".concat(antCls, "-input-affix-wrapper-focused,\n          ").concat(antCls, "-input-affix-wrapper:focus,\n          ").concat(antCls, "-input-focused,\n          ").concat(antCls, "-input:focus")] = __assign({}, active(colorWarning, colorWarningOutline)),
                    _e),
                '&-error': (_h = {},
                    _h["".concat(antCls, "-select-selector,\n            ").concat(antCls, "-cascader-picker,\n            ").concat(antCls, "-picker,\n            ").concat(antCls, "-input,\n            ").concat(antCls, "-input-number,\n            ").concat(antCls, "-input-affix-wrapper,\n            ").concat(antCls, "-input")] = {
                        borderColor: "".concat(colorError, " !important"),
                    },
                    _h["".concat(antCls, "-select-selector,\n            ").concat(antCls, "-cascader-picker,\n            ").concat(antCls, "-picker,\n            ").concat(antCls, "-input,\n            ").concat(antCls, "-input-number,\n            ").concat(antCls, "-input-affix-wrapper,\n            ").concat(antCls, "-input-affix-wrapper:hover,\n            ").concat(antCls, "-input:hover")] = {
                        borderColor: "".concat(colorError, "  !important"),
                    },
                    _h["".concat(antCls, "-select:not(").concat(antCls, "-select-disabled):not(").concat(antCls, "-select-customize-input)")] = (_j = {},
                        _j["".concat(antCls, "-select-selector")] = {
                            borderColor: "".concat(colorError, "  !important"),
                        },
                        _j["&".concat(antCls, "-select-open ").concat(antCls, "-select-selector,\n                &").concat(antCls, "-select-focused ").concat(antCls, "-select-selector")] = __assign({}, active(colorError, colorErrorOutline)),
                        _j),
                    _h["".concat(antCls, "-input-number,\n            ").concat(antCls, "-picker")] = (_k = {
                            borderColor: colorError
                        },
                        _k["&-focused,\n            &:focus"] = __assign({}, active(colorError, colorErrorOutline)),
                        _k["&:not([disabled]):hover"] = {
                            borderColor: colorError,
                        },
                        _k),
                    _h["".concat(antCls, "-cascader-picker:focus ").concat(antCls, "-cascader-input")] = __assign({}, active(colorError, colorErrorOutline)),
                    _h["".concat(antCls, "-input-affix-wrapper-focused,\n            ").concat(antCls, "-input-affix-wrapper:focus,\n            ").concat(antCls, "-input-focused,\n            ").concat(antCls, "-input:focus")] = __assign({}, active(colorError, colorErrorOutline)),
                    _h),
                '&-feedback-layout': {
                    '&-terse': (_l = {
                            marginBottom: marginSM
                        },
                        _l["&".concat(componentCls, "-feedback-has-text:not(").concat(componentCls, "-inset)")] = {
                            marginBottom: 0,
                        },
                        _l),
                    '&-loose': (_m = {
                            marginBottom: marginLG
                        },
                        _m["&".concat(componentCls, "-feedback-has-text:not(").concat(componentCls, "-inset)")] = {
                            marginBottom: Math.max(marginLG - extraLabelHeight, 0),
                        },
                        _m),
                    '&-none': (_o = {
                            marginBottom: 0
                        },
                        _o["&".concat(componentCls, "-feedback-has-text:not(").concat(componentCls, "-inset)")] = {
                            marginBottom: 0,
                        },
                        _o),
                },
                '&-control-wrap': (_p = {},
                    _p["".concat(componentCls, "-control")] = {
                        whiteSpace: 'pre-line',
                        wordBreak: 'break-all',
                    },
                    _p),
                '&-control-align': {
                    '&-left': (_q = {},
                        _q["".concat(componentCls, "-control-content")] = {
                            justifyContent: 'flex-start',
                        },
                        _q),
                    '&-right': (_r = {},
                        _r["".concat(componentCls, "-control-content")] = {
                            justifyContent: 'flex-end',
                        },
                        _r),
                },
                "input[type='radio'], input[type='checkbox']": {
                    width: fontSize,
                    height: fontSize,
                },
                '&-feedback-layout-popover': {
                    marginBottom: 8,
                },
                '&-fullness': (_s = {},
                    _s["> ".concat(componentCls, "-control")] = (_t = {},
                        _t["> ".concat(componentCls, "-control-content")] = (_u = {},
                            _u["> ".concat(componentCls, "-control-content-component")] = {
                                '> *:first-child': {
                                    width: '100%',
                                },
                            },
                            _u),
                        _t),
                    _s),
                '&-inset': (_v = {
                        borderRadius: 2,
                        border: "1px solid ".concat(colorBorder),
                        paddingInlineStart: 12,
                        transition: '0.3s all'
                    },
                    _v["".concat(antCls, "-input-number,\n          ").concat(antCls, "-picker,\n          ").concat(antCls, "-cascader-picker:focus ").concat(antCls, "-cascader-input,\n          ").concat(antCls, "-select:not(").concat(antCls, "-select-customize-input)\n          ").concat(antCls, "-select-selector,\n          ").concat(antCls, "-input-affix-wrapper,\n          ").concat(antCls, "-input")] = {
                        border: 'none !important',
                        boxShadow: 'none !important',
                    },
                    _v["".concat(antCls, "-input-number-handler-wrap")] = (_w = {
                            border: 'none !important'
                        },
                        _w["".concat(antCls, "-input-number-handler")] = {
                            border: 'none !important',
                        },
                        _w),
                    _v['&:hover'] = __assign({}, hover()),
                    _v),
                '&-active': (_x = {},
                    _x["".concat(componentCls, "-control-content-component-has-feedback-icon")] = __assign({}, active()),
                    _x["".concat(antCls, "-input-number,\n          ").concat(antCls, "-picker,\n          ").concat(antCls, "-cascader-picker:focus ").concat(antCls, "-cascader-input,\n          ").concat(antCls, "-select:not(").concat(antCls, "-select-customize-input)\n          ").concat(antCls, "-select-selector,\n          ").concat(antCls, "-input")] = __assign({}, active()),
                    _x),
                '&-inset-active': __assign({}, active()),
                '&-bordered-none': (_y = {},
                    _y["".concat(antCls, "-input-number,\n          ").concat(antCls, "-input-affix-wrapper,\n          ").concat(antCls, "-picker,\n          ").concat(antCls, "-cascader-picker:focus ").concat(antCls, "-cascader-input,\n          ").concat(antCls, "-select:not(").concat(antCls, "-select-customize-input)\n          ").concat(antCls, "-select-selector,\n          ").concat(antCls, "-input")] = {
                        border: 'none !important',
                        boxShadow: 'none !important',
                    },
                    _y["".concat(antCls, "-input-number-handler-wrap")] = (_z = {
                            border: 'none !important'
                        },
                        _z["".concat(antCls, "-input-number-handler")] = {
                            border: 'none !important',
                        },
                        _z),
                    _y),
                '&:hover': (_0 = {},
                    _0["".concat(componentCls, "-control-content-component-has-feedback-icon")] = __assign({}, hover()),
                    _0)
            },
            _b["textarea".concat(antCls, "-input")] = {
                height: 'auto',
            },
            _b["".concat(componentCls, "-label-tooltip-icon")] = {
                marginInlineStart: 4,
                color: token.colorTextSecondary,
                display: 'flex',
                alignItems: 'center',
                maxHeight: controlHeight,
                span: {
                    display: 'inline-block',
                },
            },
            _b["".concat(componentCls, "-asterisk")] = {
                color: colorError,
                marginInlineEnd: '4px',
                display: 'inline-block',
                fontFamily: 'SimSun, sans-serif',
            },
            _b["".concat(componentCls, "-colon")] = {
                marginInlineStart: 2,
                marginInlineEnd: 8,
            },
            _b["".concat(componentCls, "-control")] = (_1 = {
                    flex: 1,
                    maxWidth: '100%'
                },
                _1["".concat(componentCls, "-control-content")] = (_2 = {
                        display: 'flex'
                    },
                    _2["".concat(componentCls, "-control-content-component")] = (_3 = {
                            width: '100%',
                            minHeight: controlHeight - 2,
                            lineHeight: "".concat(controlHeight - 2, "px")
                        },
                        _3["&-has-feedback-icon"] = {
                            flex: 1,
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                        },
                        _3),
                    _2["".concat(componentCls, "-addon-before ")] = {
                        marginInlineEnd: 8,
                        display: 'inline-flex',
                        alignItems: 'center',
                        minHeight: controlHeight,
                        flexShrink: 0,
                    },
                    _2["".concat(componentCls, "-addon-after")] = {
                        marginInlineStart: 8,
                        display: 'inline-flex',
                        alignItems: 'center',
                        minHeight: controlHeight,
                        flexShrink: 0,
                    },
                    _2),
                _1["".concat(componentCls, "-help,\n        ").concat(componentCls, "-extra ")] = {
                    minHeight: extraLabelHeight,
                    lineHeight: "".concat(extraLabelHeight, "px"),
                    color: colorTextSecondary,
                },
                _1),
            _b["".concat(componentCls, "-help,\n          ").concat(componentCls, "-extra")] = {
                clear: 'both',
                minHeight: extraLabelHeight,
                color: 'rgba(0, 0, 0, 0.45)',
                transition: 'color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1)',
                paddingTop: 0,
            },
            _b["".concat(componentCls, "-control-content-component-has-feedback-icon")] = (_4 = {
                    borderRadius: 2,
                    border: "1px solid ".concat(colorBorder),
                    paddingInlineEnd: 8,
                    transition: 'all 0.3s',
                    touchAction: 'manipulation',
                    outline: 'none'
                },
                _4["".concat(antCls, "-input-number,\n            ").concat(antCls, "-picker,\n            ").concat(antCls, "-cascader-picker:focus ").concat(antCls, "-cascader-input,\n            ").concat(antCls, "-select:not(").concat(antCls, "-select-customize-input)\n            ").concat(antCls, "-select-selector,\n            ").concat(antCls, "-input-affix-wrapper,\n            ").concat(antCls, "-input")] = {
                    border: 'none !important',
                    boxShadow: 'none !important',
                },
                _4),
            _b["".concat(componentCls, "-error-help")] = {
                color: "".concat(colorError, "  !important"),
            },
            _b["".concat(componentCls, "-warning-help")] = {
                color: "".concat(colorWarning, " !important"),
            },
            _b["".concat(componentCls, "-success-help")] = {
                color: "".concat(colorSuccess, " !important"),
            },
            _b["".concat(antCls, "-upload")] = {
                background: 'transparent',
            },
            _b["".concat(antCls, "-upload").concat(antCls, "-upload-drag")] = {
                background: token.colorBgBase,
            },
            _b["".concat(antCls, "-radio-inline, ").concat(antCls, "-checkbox-inline")] = {
                display: 'inline-block',
                marginInlineStart: marginSM,
                fontWeight: 'normal',
                verticalAlign: 'middle',
                cursor: 'pointer',
                '&:first-child': {
                    marginInlineStart: 0,
                },
            },
            _b["".concat(antCls, "-radio-vertical,\n          ").concat(antCls, "-checkbox-vertical")] = {
                display: 'block',
            },
            _b["".concat(antCls, "-checkbox-vertical + ").concat(antCls, "-checkbox-vertical,\n          ").concat(antCls, "-radio-vertical + ").concat(antCls, "-radio-vertical")] = {
                marginInlineStart: 0,
            },
            _b["".concat(antCls, "-input-number")] = (_5 = {
                    width: '100%',
                    verticalAlign: 'top'
                },
                _5["+ ".concat(antCls, "-form-text")] = {
                    marginInlineStart: marginSM,
                },
                _5['&-handler-wrap'] = {
                    zIndex: 2,
                },
                _5),
            _b["".concat(antCls, "-select,\n          ").concat(antCls, "-cascader-picker,\n          ").concat(antCls, "-picker")] = {
                width: '100%',
            },
            _b["".concat(antCls, "-input-group ").concat(antCls, "-select,\n          ").concat(antCls, "-input-group ").concat(antCls, "-cascader-picker")] = {
                width: 'auto',
            },
            _b['&-popover'] = (_6 = {},
                _6["".concat(componentCls, "-error-help")] = {
                    color: "".concat(colorError, "  !important"),
                },
                _6["".concat(componentCls, "-warning-help")] = {
                    color: colorWarning,
                },
                _6["".concat(componentCls, "-success-help")] = {
                    color: "".concat(colorSuccess, " !important"),
                },
                _6),
            _b),
        _a;
};
//# sourceMappingURL=other.js.map